const transformGuestData = data =>
  Object.fromEntries(data.fields.map(({ key, value }) => [key, value]));

export const guestMapper = guest => {
  const guestData = transformGuestData(guest);
  const {
    email: Email,
    name: Name,
    surname: Surname,
    second_surname: SecondSurname,
    sex: Gender,
    birth_date: BirthDate,
    nationality: Nationality,
    document_type: DocumentType,
    document_number: DocumentNumber,
    document_country: DocumentCountry,
    expedition_date: ExpeditionDate,
    expiration_date: ExpirationDate,
    // AssignedRoom
    // PersonType
    address,
    arrivalFlight,
    arrivalFlightTime,
    arrivalTime,
    birthCity,
    birthCountry,
    birthProvince,
    birthState, // ?
    businessAddress,
    businessName,
    businessNumber,
    city,
    country,
    customerNotes,
    dailyCleaning,
    departureFlight,
    departureFlightTime,
    departureTime,
    document_support_number,
    documentIssuanceCountry,
    documentIssuanceProvince,
    documentIssuanceCity,
    email,
    environmentalTax,
    relationship, // ?
    family_relationship, // ?
    firstTime,
    guestType,
    hostelIntNumber,
    hotelInsurance,
    howMeet,
    maritalStatus,
    meansOfTransport,
    memberNumber,
    mobilityProblems,
    municipalityCode, // ?
    noCommonAllergy, // ?
    occupation,
    parking,
    paymentType,
    phone,
    plateNumber,
    postalCode,
    province,
    state,
    travelReason,
    taxId, // ?
  } = guestData;

  return {
    Email,
    Name,
    Surname,
    SecondSurname,
    Gender,
    BirthDate,
    Nationality,
    DocumentType,
    DocumentNumber,
    DocumentCountry,
    ExpeditionDate,
    ExpirationDate,
    AssignedRoom: '',
    PersonType: '',
    CustomFields: {
      address,
      allergy: null,
      arrivalFlight,
      arrivalFlightTime,
      arrivalTime,
      birthCity,
      birthCountry,
      birthProvince,
      birthState,
      businessAddress,
      businessName,
      businessNumber,
      city,
      country,
      customerNotes,
      dailyCleaning,
      departureFlight,
      departureFlightTime,
      departureTime,
      document_support_number,
      documentIssuanceCountry,
      documentIssuanceProvince,
      documentIssuanceCity,
      email,
      environmentalTax,
      family_relationship: family_relationship ?? relationship,
      firstTime,
      guestType,
      hostelIntNumber,
      hotelInsurance,
      howMeet,
      maritalStatus,
      meansOfTransport,
      memberNumber,
      mobilityProblems,
      municipalityCode,
      noCommonAllergy,
      occupation,
      parking,
      paymentType,
      phone,
      plateNumber,
      postalCode,
      province,
      state,
      travelReason,
      taxId,
    },
  };
};
